import { api } from "@/apps/common/api-client";
import PageTitle from "@/apps/common/components/PageTitle";
import Form from "@/modules/react-jsonschema-form-bootstrap";
import { RJSFSchema } from "@rjsf/utils";
import validator from "@rjsf/validator-ajv8";
import { useRequest } from "ahooks";
import { Spinner } from "react-bootstrap";

const schema: RJSFSchema = {
  type: "object",
  properties: {
    // problem: { type: "string", title: "Problem" },
    // findings: { type: "string", title: "Findings" },
    // assessment: { type: "string", title: "Assessment" },
    // observation: { type: "string", title: "Observation" },
    next_plan: { type: "string", title: "Plan for Next Time" },
    treatment_plan_1: {
      type: "object",
      title: "Treatment Plan 1",
      properties: {
        goal: { type: "string", title: "Goal" },
        objective_1: { type: "string", title: "Objective 1" },
        progress_1: { type: "string", title: "Progress 1" },
        objective_2: { type: "string", title: "Objective 2" },
        progress_2: { type: "string", title: "Progress 2" }
      }
    },
    treatment_plan_2: {
      type: "object",
      title: "Treatment Plan 2",
      properties: {
        goal: { type: "string", title: "Goal" },
        objective_1: { type: "string", title: "Objective 1" },
        progress_1: { type: "string", title: "Progress 1" },
        objective_2: { type: "string", title: "Objective 2" },
        progress_2: { type: "string", title: "Progress 2" }
      }
    }
  }
};

const uiSchema = {
  "ui:submitButtonOptions": {
    norender: true
  },
  problem: {
    "ui:widget": "textarea",
    "ui:options": { rows: 8 }
  },
  findings: {
    "ui:widget": "textarea",
    "ui:options": { rows: 8 }
  },
  assessment: {
    "ui:widget": "textarea",
    "ui:options": { rows: 8 }
  },
  observation: {
    "ui:widget": "textarea",
    "ui:options": { rows: 8 }
  },
  next_plan: {
    "ui:widget": "textarea",
    "ui:options": { rows: 8 }
  },
  treatment_plan_2: {
    progress_1: {
      "ui:widget": "textarea",
      "ui:options": { rows: 8 }
    },
    progress_2: {
      "ui:widget": "textarea",
      "ui:options": { rows: 8 }
    }
  },
  treatment_plan_1: {
    progress_1: {
      "ui:widget": "textarea",
      "ui:options": { rows: 8 }
    },
    progress_2: {
      "ui:widget": "textarea",
      "ui:options": { rows: 8 }
    }
  }
};

function ProgressNotesRenderer({
  data
}: {
  data: (typeof schema)["properties"];
}) {
  return (
    <div className="flex flex-col gap-4">
      <Form
        formData={data}
        schema={schema as any}
        uiSchema={uiSchema}
        validator={validator}
        noHtml5Validate
        liveValidate={false}
        showErrorList={false}
        disabled
      ></Form>
    </div>
  );
}

export default function ProgressNotes() {
  const {
    data: providerReportResponse,
    loading,
    error
  } = useRequest(() => api.memberServices.findLatestCompletedMemberService(), {
    refreshDeps: []
  });

  return (
    <>
      <PageTitle title={"Progress Notes"} />
      {loading ? <Spinner /> : null}

      {!loading && error ? (
        <div className="flex flex-col gap-4">
          <p className="text-red-500">Error: {error.message}</p>
        </div>
      ) : null}
      {!loading && !error && providerReportResponse ? (
        <ProgressNotesRenderer
          data={
            providerReportResponse[
              "Progress_Notes"
            ] as (typeof schema)["properties"]
          }
        />
      ) : (
        <div className="flex flex-col gap-4">
          <p>No progress notes available.</p>
        </div>
      )}
    </>
  );
}
